<div
  *ngIf="
    formName.controls[fieldName].invalid &&
    (formName.controls[fieldName].dirty || formName.controls[fieldName].touched)
">
  <div *ngIf="formName.controls[fieldName].errors?.required">
    * {{fieldName}}
  </div>
</div>
